import { Logger } from '@aws-amplify/core';
import { isDevelopment } from './env';

const logLevel = isDevelopment ? 'DEBUG' : 'WARN';
const logger = new Logger('Gandalf', logLevel);

export default logger;
